import * as React from "react";
import {
    Filter,
    DateInput,
    List,
    Datagrid,
    TextField,
    BooleanField,
    DateField,
    useRecordContext,
    SelectInput,
    ExportButton,
    TopToolbar, TextInput,
    useListContext,
} from "react-admin";
import {Box} from "@material-ui/core";
import Paginator from "./Paginator";
import {visitOutcomes} from "../../Constants/visitOutcomes";
import {Typography} from "@material-ui/core";

const ListActions = (props) => {
    const {
        className,
        maxResults,
        perPage,
        page,
        total,
        ...rest
    } = props;
    const pageStart = (page - 1) * perPage;
    const pageFinish = pageStart + perPage;
    return (
        <TopToolbar>
            <ExportButton label={"Download"} maxResults={pageFinish}/>
        </TopToolbar>
    );
};
const AppointmentFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search By Last Name" source="parentLastName" initialValue={""} alwaysOn/>
        <DateInput style={{minWidth: "185px"}} label="Appointment Date" source="scheduledDate" initialValue={null} alwaysOn/>
        <SelectInput
            label="Appointment Status"
            source="status"
            style={{minWidth: "185px"}}
            choices={[
                { id: "ACCEPTED", name: "ACCEPTED" },
                { id: "REJECTED", name: "REJECTED" },
                { id: "REQUEST_MADE", name: "REQUEST MADE" },
                { id: "CANCELLED", name: "CANCELLED"}
            ]}
            initialValue={null}
            alwaysOn
        />
    </Filter>
);

const ClientName = (props) => {
    const record = useRecordContext(props);
    return <span>{record.userDetails?.ownerProfileDetails.firstName} {record.userDetails?.ownerProfileDetails.lastName}</span>;
};

const ClientType = (props) => {
    const record = useRecordContext(props);
    return <span>{record.userDetails?.ownerProfileDetails.partnerName || "Hello Ralphie"}</span>;
};

const ClientPhone = (props) => {
    const record = useRecordContext(props);
    return <span>{record.userDetails?.ownerProfileDetails.phoneNumber}</span>;
};

const VetName = (props) => {
    const record = useRecordContext(props);
    return <span>{record.userDetails?.vetProfileDetails ? `Dr.` + record.userDetails?.vetProfileDetails.lastName : "Rhapsody"}</span>;
};

const Outcome = (props) => {
    const record = useRecordContext(props);
    const outcome = visitOutcomes.find(({value}) => value === record.userDetails?.visitOutcomes)?.label
    return <>
        <span>{outcome}</span>
    </>;
};

const AppointmentList = (props) => {
    return(
        <List {...props} actions={<ListActions/>} filters={<AppointmentFilter/>} pagination={<Paginator />}  >
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <TextField source="animal.name" label="Animal"/>
                <ClientName label="Client Name" />
                <ClientType label="Client Type" />
                <ClientPhone label="Client Phone" />
                <VetName label="Vet Name"/>
                <TextField source="type" />
                <DateField source="scheduledDate" showTime={true} label={`Scheduled Date ${new Date().toString().match(/([A-Z]+[\\+-][0-9]+.*)/)[0].slice(0, 6) + ":" + new Date().toString().match(/([A-Z]+[\\+-][0-9]+.*)/)[0].slice(6)}`}/>
                <TextField source="status" />
                <BooleanField source="isSendRecords" label="Release notes"/>
                <BooleanField source="finished" />
                <DateField source="actualStartTime" showTime={true} />
                <DateField source="actualEndTime" showTime={true} />
                <Outcome label="Outcome" />
                {/* <DateField source="zipCode" /> */}
            </Datagrid>
        </List>
    );
};

export default AppointmentList;
